document.addEventListener('DOMContentLoaded', () => {
  const shell = document.querySelector('.mww-site-shell');
  const intro = document.querySelector('[data-mww-intro]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.documentElement.classList.add('motion-ready');

  if (intro && !window.Shopify?.designMode) {
    document.body.classList.add('mww-is-loading');
    const leaveDelay = reduceMotion ? 0 : 1050;
    const removeDelay = reduceMotion ? 0 : 650;

    window.setTimeout(() => {
      intro.classList.add('mww-brand-intro--leaving');
      window.setTimeout(() => {
        intro.remove();
        document.body.classList.remove('mww-is-loading');
        shell?.classList.add('mww-site-shell--ready');
      }, removeDelay);
    }, leaveDelay);
  } else {
    intro?.remove();
    shell?.classList.add('mww-site-shell--ready');
  }

  const revealElements = Array.from(document.querySelectorAll('[data-reveal]'));
  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealElements.forEach((element) => element.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });

  revealElements.forEach((element) => observer.observe(element));
});
